"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.placeholderCategories = exports.readycableCategories = exports.chainflexCategories = exports.LeitungCategory = void 0;
var LeitungCategory;
(function (LeitungCategory) {
    // chainflex
    LeitungCategory["ControlCables"] = "ControlCables";
    LeitungCategory["DataCables"] = "DataCables";
    LeitungCategory["MotorCables"] = "MotorCables";
    LeitungCategory["ServoCables"] = "ServoCables";
    LeitungCategory["PneumaticHoses"] = "PneumaticHoses";
    LeitungCategory["CoaxCables"] = "CoaxCables";
    LeitungCategory["FibreOpticCables"] = "FibreOpticCables";
    LeitungCategory["MeasuringSystemCables"] = "MeasuringSystemCables";
    LeitungCategory["BusCables"] = "BusCables";
    LeitungCategory["RobotCables"] = "RobotCables";
    LeitungCategory["SpecialCables"] = "SpecialCables";
    LeitungCategory["HydraulicCables"] = "HydraulicCables";
    LeitungCategory["HybridCables"] = "HybridCables";
    // PullWires
    LeitungCategory["PullWires"] = "PullWires";
    // readycable
    LeitungCategory["DriveTech"] = "DriveTech";
    LeitungCategory["NetTech"] = "NetTech";
    LeitungCategory["SensorActor"] = "SensorActor";
    LeitungCategory["VideoVisionBus"] = "VideoVisionBus";
    LeitungCategory["HartingIndustrialConnectors"] = "HartingIndustrialConnectors";
    LeitungCategory["RcRobotic"] = "RcRobotic";
})(LeitungCategory = exports.LeitungCategory || (exports.LeitungCategory = {}));
/**
 * All categories of chainflex.
 */
exports.chainflexCategories = [
    LeitungCategory.BusCables,
    LeitungCategory.CoaxCables,
    LeitungCategory.ControlCables,
    LeitungCategory.DataCables,
    LeitungCategory.FibreOpticCables,
    LeitungCategory.HydraulicCables,
    LeitungCategory.MeasuringSystemCables,
    LeitungCategory.MotorCables,
    LeitungCategory.PneumaticHoses,
    LeitungCategory.RobotCables,
    LeitungCategory.ServoCables,
    LeitungCategory.SpecialCables,
    LeitungCategory.HybridCables,
    LeitungCategory.PullWires,
];
/**
 * All categories of readycable.
 */
exports.readycableCategories = [
    LeitungCategory.DriveTech,
    LeitungCategory.NetTech,
    LeitungCategory.SensorActor,
    LeitungCategory.VideoVisionBus,
    LeitungCategory.HartingIndustrialConnectors,
    LeitungCategory.RcRobotic,
];
/**
 * All categories of placeholder.
 */
exports.placeholderCategories = [
    LeitungCategory.BusCables,
    LeitungCategory.ControlCables,
    LeitungCategory.DataCables,
    LeitungCategory.HydraulicCables,
    LeitungCategory.MeasuringSystemCables,
    LeitungCategory.MotorCables,
    LeitungCategory.PneumaticHoses,
    LeitungCategory.ServoCables,
    LeitungCategory.PullWires,
];
//# sourceMappingURL=LeitungCategory.js.map